export const GenAIModels = [
    { label: "GPT-4o", value: "GPT-4o" },
    { label: "GROK2", value: "GROK2" },
    { label: "GROK3", value: "grok-3" },
    { label: "Grok 4.1 Fast Non-Reasoning", value: "grok-4-1-fast-non-reasoning" },
    { label: "gemini-2.0-flash", value: "gemini-2.0-flash" },
    { label: "Open AI GPT 4.1", value: "openai-gpt-4.1" },
    { label: "Open AI GPT 4.1 Mini", value: "openai-gpt-4.1-mini" },
    { label: "gemini-2.5-flash", value: "gemini-2.5-flash" },
    { label: "gemini-2.5-flash-preview-04-17", value: "gemini-2.5-flash-preview-04-17" },
    { label: "gemini-2.5-flash-preview-05-20", value: "gemini-2.5-flash-preview-05-20" },
    { label: "gemini-3-flash-preview", value: "gemini-3-flash-preview" },
    { label: "gemini-3-flash", value: "gemini-3-flash" }
]